var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5247 5.44502C2.39999 6.56973 2.39999 8.37993 2.39999 12.0003C2.39999 15.6207 2.39999 17.4309 3.5247 18.5556C4.64941 19.6803 6.45961 19.6803 10.08 19.6803H13.92C17.5404 19.6803 19.3506 19.6803 20.4753 18.5556C21.6 17.4309 21.6 15.6207 21.6 12.0003C21.6 8.37993 21.6 6.56973 20.4753 5.44502C19.3506 4.32031 17.5404 4.32031 13.92 4.32031H10.08C6.45961 4.32031 4.64941 4.32031 3.5247 5.44502ZM18.3131 7.69938C18.5677 8.00486 18.5264 8.45887 18.2209 8.71343L16.1123 10.4706C15.2614 11.1797 14.5717 11.7545 13.963 12.146C13.3289 12.5538 12.7114 12.8114 12 12.8114C11.2886 12.8114 10.671 12.5538 10.037 12.146C9.42827 11.7545 8.7386 11.1797 7.8877 10.4706L5.77906 8.71343C5.47358 8.45887 5.43231 8.00486 5.68687 7.69938C5.94144 7.3939 6.39545 7.35263 6.70093 7.60719L8.77347 9.33431C9.66911 10.0807 10.2909 10.5972 10.8159 10.9348C11.3241 11.2617 11.6687 11.3714 12 11.3714C12.3313 11.3714 12.6759 11.2617 13.1841 10.9348C13.7091 10.5972 14.3309 10.0807 15.2265 9.33431L17.2991 7.60719C17.6045 7.35263 18.0585 7.3939 18.3131 7.69938Z",
    fill: "#F6932B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Email.c02cbb3e.svg";
export { ForwardRef as ReactComponent };